import styled, { css } from 'styled-components';
import theme from 'theme';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const linkStyles = css`
    text-decoration: none;
    color: ${theme.colors.main};
    font-size: ${theme.typography.base_font_size};
    font-family: ${theme.fonts.medium};

    &:hover {
        text-decoration: underline;
    }
`;

export const CommonLink = styled.a`
    ${linkStyles};
`;

export const CommonRouterLink = styled(Link)`
    ${linkStyles};
`;

export const ButtonAsLink = styled.button`
    background-color: transparent;
    color: ${theme.colors.main};
    font-size: ${theme.typography.base_font_size};
    font-family: ${theme.fonts.medium};
    padding: 0;
    &:hover {
        text-decoration: underline;
    }
`;

export const PageWrapper = styled.main`
    background-color: ${theme.colors.gray_light};
    padding: 20px;

    @media (max-width: 1175px) {
        max-width: 100vw;
    }
`;

export const PageHeading = styled.h1`
    color: ${theme.colors.gray_darker};
    font-family: ${theme.fonts.regular};
    font-size: 22px;
`;

export const QuestionIcon = styled(FontAwesomeIcon)`
    height: 13px;
    width: 13px;
    margin: 0 3px;
    cursor: pointer;
    color: ${theme.colors.gray_dark};
`;
export const PopoverContent = styled.div`
    font-size: 12px;
    max-width: 320px;
`;
